import * as React from 'react';
import { useEffect, useState } from 'react';
import { AppListView } from './view';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { PageInfo, useAppListQuery } from '../../../types/generated';
import { Button, Container } from '@material-ui/core';

export const AppList = () => {
    const [pageInfo, setPageInfo] = useState<PageInfo>();
    const [cursor, setCursor] = useState<string | undefined>();
    const [edges, setEdges] = useState<Array<any>>([]);
    const query = {
        after: cursor,
        first: 10,
    };

    const { data, refetch } = useAppListQuery({
        variables: query,
        onCompleted: d => {
            const { pageInfo: pInfo } = d.apps;
            if (pInfo) {
                setPageInfo(pInfo);
            }

            if (d.apps?.edges?.length > 0) {
                const newEdges = d.apps.edges;
                setEdges([...edges, ...newEdges]);
            }
        },
    });

    const navigate = useNavigate();
    const onCreate = () => {
        navigate('/extranet/apps/new');
    };

    useEffect(() => {
        (async () => {
            const res = await refetch(query);

            if (res.data.apps.edges) {
                setEdges(res.data.apps.edges);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data) {
        return (
            <>
                <AppListView list={data && edges} onCreate={onCreate} />
                {pageInfo?.hasNextPage && pageInfo?.endCursor && (
                    <Container
                        maxWidth={'md'}
                        style={{ display: 'flex', justifyContent: 'center', paddingTop: 24 }}
                    >
                        <Button onClick={() => setCursor(pageInfo.endCursor)}>Load more</Button>
                    </Container>
                )}
            </>
        );
    } else {
        return <CircularProgress />;
    }
};
